module.exports = __webpack_public_path__ + "img/icon-pick-02.f921c67a.svg";